import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkCard, UitkCardContent } from 'uitk-react-cards';
import { UitkIcon } from 'uitk-react-icons';

const LinkTracked = ClickTracker(Link);

export const HisTopEntry = ({ headerTitle, jsEnabled, linkClassNames, routeStore, placeholder }) => (
  <div className="s-b-padding-three m-b-padding-three" data-stid="section-info-find-answers-1">
    <UitkCard
      className="
        s-x-padding-three
        m-x-padding-three
        l-x-padding-six
        l-y-margin-three
        xl-y-margin-three
        xl-x-padding-six
        all-y-padding-six"
    >
      <UitkCardContent>
        <span className="all-r-margin-one">{headerTitle}</span>
        <LinkTracked
          linkName="Open Find Answers"
          disabled={!jsEnabled}
          rfrr="AskQuestion.FindAnswersTopEntry"
          className={linkClassNames.join(' ')}
          to={{
            search: routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: 'findAnswers' })
          }}
        >
          <UitkIcon name="search" />
          {placeholder}
        </LinkTracked>
      </UitkCardContent>
    </UitkCard>
  </div>
);

HisTopEntry.displayName = 'HisTopEntry';
